import { BasketManagerFilterProps } from '@epicuro-next/constants/features/full-basket-manager';
import {
  basketManagerDefaultColumns,
  basketManagerDefaultFilters,
  BasketManagerTableProps,
} from '@epicuro-next/data/basket-manager';
import { IConfigurations } from '@epicuro-next/platform/configuration';

export const FULL_PAGE_BASKET_MANAGER_NAMESPACE = 'full-page-basket-manager';

/**
 * configuration keys for this module
 */
export enum FullBasketManagerConfigurationKeys {
  FullPageBasketManager = 'full-page-basket-manager',
  ListColumns = 'list-columns',
  AvailableFilters = 'available-filters',
  MultipleFilters = 'multiple-filters',
  FiltersWithQuery = 'filters-with-query',
  PreSelectAccountFilters = 'pre-select-accounts-filter',
  PreSelectUsersFilter = 'pre-select-users-filter',
  PreserveFiltersSelection = 'preserve-filters-selection',
  ShowBasketsDownloadButton = 'show-baskets-download-button',
  ShowBasketsMergeButton = 'show-baskets-merge-button',
  BypassSelectionRestrictions = 'bypass-selection-restrictions',
  ShowResendConfirmationButton = 'show-resend-confirmation-button',
}

/**
 * Configuration return types and default values for this module
 */
export interface FullBasketManagerConfigurations
  extends IConfigurations<FullBasketManagerConfigurationKeys> {
  [FullBasketManagerConfigurationKeys.FullPageBasketManager]: boolean;
  [FullBasketManagerConfigurationKeys.ListColumns]: BasketManagerTableProps[];
  [FullBasketManagerConfigurationKeys.AvailableFilters]: BasketManagerFilterProps[];
  [FullBasketManagerConfigurationKeys.MultipleFilters]: BasketManagerFilterProps[];
  [FullBasketManagerConfigurationKeys.FiltersWithQuery]: BasketManagerFilterProps[];
  [FullBasketManagerConfigurationKeys.PreSelectAccountFilters]: boolean;
  [FullBasketManagerConfigurationKeys.PreSelectUsersFilter]: boolean;
  [FullBasketManagerConfigurationKeys.PreserveFiltersSelection]: boolean;
  [FullBasketManagerConfigurationKeys.ShowBasketsMergeButton]: boolean;
  [FullBasketManagerConfigurationKeys.BypassSelectionRestrictions]: boolean;
  [FullBasketManagerConfigurationKeys.ShowResendConfirmationButton]: number;
}

export const fullBasketManagerDefaults: FullBasketManagerConfigurations = {
  [FullBasketManagerConfigurationKeys.FullPageBasketManager]: false,
  [FullBasketManagerConfigurationKeys.MultipleFilters]: [],
  [FullBasketManagerConfigurationKeys.FiltersWithQuery]: [],
  [FullBasketManagerConfigurationKeys.PreSelectAccountFilters]: false,
  [FullBasketManagerConfigurationKeys.PreSelectUsersFilter]: false,
  [FullBasketManagerConfigurationKeys.PreserveFiltersSelection]: false,
  [FullBasketManagerConfigurationKeys.ListColumns]: basketManagerDefaultColumns,
  [FullBasketManagerConfigurationKeys.AvailableFilters]:
    basketManagerDefaultFilters,
  [FullBasketManagerConfigurationKeys.ShowBasketsDownloadButton]: false,
  [FullBasketManagerConfigurationKeys.ShowBasketsMergeButton]: false,
  [FullBasketManagerConfigurationKeys.BypassSelectionRestrictions]: false,
  [FullBasketManagerConfigurationKeys.ShowResendConfirmationButton]: 0,
};
